import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import { hasBackofficeAccess } from '@/lib/auth-access'
import { LoginPage } from '@/pages/auth/LoginPage'
import { useAuthStore } from '@/store/auth.store'

/** Token varken bile rol uygun değilse oturumu temizler; uygunsa panele yönlendirir. */
export function LoginGate() {
  const token = useAuthStore((s) => s.token)
  const user = useAuthStore((s) => s.user)
  const logout = useAuthStore((s) => s.logout)

  useEffect(() => {
    if (token && !hasBackofficeAccess(user)) {
      logout()
    }
  }, [token, user, logout])

  if (token && hasBackofficeAccess(user)) {
    return <Navigate to="/" replace />
  }

  return <LoginPage />
}
